import React from "react";
import { X } from "lucide-react";

export default function TermsModal({ title, text, onClose }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm overflow-y-auto" onClick={onClose}>
      <div className="flex min-h-full items-center justify-center p-4">
        <div
          onClick={(e) => e.stopPropagation()}
          className="bg-[#15151f] border border-white/10 rounded-2xl p-6 w-full max-w-2xl fade-up my-8"
          data-testid="terms-modal"
        >
          <div className="flex items-center justify-between mb-4">
            <h3 className="brand-title text-xl">{title}</h3>
            <button onClick={onClose} className="text-white/60 hover:text-white" aria-label="Close" data-testid="terms-modal-close">
              <X size={20} />
            </button>
          </div>
          <div className="max-h-[65vh] overflow-y-auto pr-2 text-sm text-white/75 whitespace-pre-wrap leading-relaxed">
            {text}
          </div>
        </div>
      </div>
    </div>
  );
}
